__turbopack_context__.v({
  "className": "DhLdIa_className",
  "variable": "DhLdIa_variable",
});
